module.exports = __webpack_public_path__ + "img/6.80831752.jpg";